(() => {
  // Hide grid immediately before anything renders
  const grid = document.querySelector('ul#product-grid, ul[id^="product-grid"], .product-grid');
  if (grid) grid.style.visibility = 'hidden';

  const showGrid = () => {
    if (grid) grid.style.visibility = 'visible';
  };

  const qp = new URLSearchParams(location.search);
  const currentPage = parseInt(qp.get('page') || '1', 10);
  const pathParts = location.pathname.split('/').filter(Boolean);
  const COLLECTION = pathParts[0] === 'collections' ? pathParts[1] : '';

  let rawFirst = decodeURIComponent((qp.get('first') || '').trim());
  let firstHandle = '';

  if (rawFirst.startsWith('http')) {
    try {
      const u = new URL(rawFirst);
      const segs = u.pathname.split('/').filter(Boolean);
      if (segs[0] === 'products' && segs[1]) firstHandle = segs[1];
    } catch (_) {}
  } else {
    const segs = rawFirst.split('/').filter(Boolean);
    firstHandle = segs.pop();
  }

  let variantID = /^\d+$/.test(qp.get('variant') || '')
    ? qp.get('variant')
    : '';

  // Clear bumped_product if collection changed
  const savedCollection = sessionStorage.getItem('pinned_collection');
  if (savedCollection && savedCollection !== COLLECTION) {
    sessionStorage.removeItem('bumped_product');
  }
  sessionStorage.setItem('pinned_collection', COLLECTION);

  // ── Page 1: restore firstHandle and variantID from sessionStorage only if same collection ──
  if (!firstHandle && currentPage < 2) {
    const saved = sessionStorage.getItem('pinned_product');
    if (saved) {
      const parsed = JSON.parse(saved);
      const pinnedCol = sessionStorage.getItem('pinned_product_collection');
      if (pinnedCol === COLLECTION) {
        firstHandle = parsed.handle;
        if (!variantID && parsed.vid) variantID = parsed.vid;
      }
    }
  }

  // Pre-fetch product JSON early with sessionStorage cache
  const productDataPromise = (firstHandle && variantID)
    ? (() => {
        const cacheKey = `prod:${firstHandle}`;
        const cached = sessionStorage.getItem(cacheKey);
        if (cached) return Promise.resolve(JSON.parse(cached));
        return fetch(`/products/${firstHandle}.js`, { priority: 'high' })
          .then(r => r.json())
          .then(data => {
            try { sessionStorage.setItem(cacheKey, JSON.stringify(data)); } catch (_) {}
            return data;
          })
          .catch(() => null);
      })()
    : Promise.resolve(null);

  if (!grid) { showGrid(); return; }

  const applyVariant = async (cardEl, handle, vid) => {
    if (!vid) return;

    cardEl.style.visibility = 'hidden';

    cardEl.querySelectorAll('a[href*="/products/"]').forEach(a => {
      const u = new URL(a.href, location.origin);
      u.searchParams.set('variant', vid);
      a.href = u.pathname + u.search;
    });

    try {
      const prod = await productDataPromise;
      if (!prod) { cardEl.style.visibility = 'visible'; return; }

      const varObj = prod.variants.find(v => String(v.id) === vid);
      if (!varObj?.featured_image) { cardEl.style.visibility = 'visible'; return; }

      await new Promise(resolve => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = resolve;
        img.src = varObj.featured_image.src;
      });

      cardEl.querySelectorAll('img').forEach(img => {
        img.src = varObj.featured_image.src;
        img.srcset = '';
      });
    } catch (_) {}

    cardEl.style.visibility = 'visible';
  };

  const fetchAndPrepend = async (handle, vid) => {
    const r = await fetch(`/products/${encodeURIComponent(handle)}?view=card-portrait`, {
      cache: 'force-cache'
    });
    if (!r.ok) return null;
    const html = await r.text();
    if (!html.trim()) return null;
    const tmp = document.createElement('ul');
    tmp.innerHTML = html;
    const card = tmp.querySelector('li.grid__item') || tmp.firstElementChild;
    if (!card) return null;
    grid.prepend(card);
    await applyVariant(card, handle, vid);
    return card;
  };

  // ── Page 2+: only inject if bumped product is destined for THIS page ──
  if (currentPage >= 2) {
    const bumpedRaw = sessionStorage.getItem('bumped_product');
    if (bumpedRaw) {
      const bumped = JSON.parse(bumpedRaw);
      if (bumped.forPage === currentPage) {
        (async () => {
          const card = await fetchAndPrepend(bumped.handle, bumped.vid);
          if (card) {
            const allItems = grid.querySelectorAll('li.grid__item');
            const lastEl = allItems[allItems.length - 1];
            if (lastEl) {
              const lastAnchor = lastEl.querySelector('a[href*="/products/"]');
              if (lastAnchor) {
                const lastHandle = lastAnchor.href.split('/products/')[1].split('?')[0];
                sessionStorage.setItem('bumped_product', JSON.stringify({
                  handle: lastHandle,
                  vid: '',
                  forPage: currentPage + 1
                }));
              }
              lastEl.remove();
            }
          }
          showGrid();
        })();
      } else {
        showGrid();
      }
    } else {
      showGrid();
    }
    return;
  }

  if (!firstHandle) { showGrid(); return; }

  sessionStorage.setItem('pinned_product', JSON.stringify({ handle: firstHandle, vid: variantID }));
  sessionStorage.setItem('pinned_product_collection', COLLECTION);

  // ── Page 1: Case 1 — product already in DOM ──
  const items = Array.from(grid.querySelectorAll('li.grid__item'));
  const match = items.find(li => {
    const a = li.querySelector('a[href*="/products/"]');
    return a && a.href.includes(`/products/${firstHandle}`);
  });

  if (match) {
    (async () => {
      await applyVariant(match, firstHandle, variantID);
      grid.prepend(match);
      sessionStorage.removeItem('bumped_product');
      showGrid();
    })();
    return;
  }

  // ── Page 1: Case 2 — product is on another page, fetch and inject ──
  (async () => {
    try {
      const card = await fetchAndPrepend(firstHandle, variantID);
      if (!card) { showGrid(); return; }

      const allItems = grid.querySelectorAll('li.grid__item');
      if (allItems.length > 0) {
        const last = allItems[allItems.length - 1];
        const lastAnchor = last.querySelector('a[href*="/products/"]');
        if (lastAnchor) {
          const lastHandle = lastAnchor.href.split('/products/')[1].split('?')[0];
          sessionStorage.setItem('bumped_product', JSON.stringify({
            handle: lastHandle,
            vid: '',
            forPage: 2
          }));
        }
        last.remove();
      }
    } catch (_) {}
    showGrid();
  })();
})();